import { startApp } from './src';

startApp();